import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import useFontSize from '../shell/hooks/useFontSize';

interface DisclaimerProps {

}

export const Disclaimer: React.FC<DisclaimerProps> = ({ }) => {
    const styles = StyleSheet.create({
        textWrapper: {
            position:"absolute",
            backgroundColor: "#00000080",
            padding: "10%",
            flex: 1,
            width: "100%",
            alignItems: "center",
            flexDirection: "row",
            alignSelf: "center",
            textAlign: "center",
            justifyContent: "center",
            alignContent: "center"
        },
        text: {
            fontFamily: "serif",
            fontWeight: "bold",
            textShadowColor: 'rgba(0, 0, 0, 0.5)',
            textShadowRadius: 1,
            textShadowOffset: { width: 1, height: 1 },
            textAlign: "center",
            color: "white",
            display: "flex",
            flexDirection: "column",
            fontSize: useFontSize(4)

        }

    });
    return (
        <View style={styles.textWrapper}>
            <Text selectable={false} style={styles.text}>
                <Text style={{ color: "#ff2d2d" }}>WARNING!</Text>
                <Text style={{ flexDirection: "row", }}>
                    {"\n"}
                    This game is intended for individuals aged 18 and above. All characters depicted are of legal age and any resemblance to real persons, living or dead, or events, is purely coincidental. The content is entirely fictional and does not represent any real events or people. If you are not of legal age, please exit the game immediately. Continued play signifies your consent and acknowledgment of these terms.
                    {"\n"}
                </Text>
            </Text>
        </View>);
};